import styled from 'styled-components'
import { colors, fieldLabel, fontScope, radius } from '../tokens'

export const Field = styled.div`
  ${fontScope}
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`

export const Label = styled.label<{ $dense: boolean }>`
  ${fieldLabel}
  white-space: nowrap;
  ${({ $dense }) => ($dense ? 'line-height: normal; letter-spacing: 0;' : '')}
`

export const Box = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  min-height: 40px;
  border: 1px solid ${colors.border};
  border-radius: ${radius.input};
  background: ${colors.white};

  &:focus-within {
    border-color: ${colors.ink400};
  }
`

export const Input = styled.input`
  flex: 1;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  padding: 9.5px 44px 9.5px 16px;
  border: 0;
  background: transparent;
  outline: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${colors.ink950};

  &::-webkit-calendar-picker-indicator {
    position: absolute;
    right: 12px;
    width: 24px;
    height: 24px;
    margin: 0;
    opacity: 0;
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    color: ${colors.ink400};
  }
`

export const Icon = styled.img`
  position: absolute;
  right: 16px;
  pointer-events: none;
`
